var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 8.68063C2.5 6.01597 2.5 4.68365 2.8146 4.23542C3.12919 3.7872 4.38194 3.35838 6.88743 2.50074L7.36477 2.33735C8.67082 1.89028 9.32384 1.66675 10 1.66675C10.6762 1.66675 11.3292 1.89028 12.6352 2.33735L13.1126 2.50074C15.6181 3.35838 16.8708 3.7872 17.1854 4.23542C17.5 4.68365 17.5 6.01597 17.5 8.68063V9.99288C17.5 14.6913 13.9675 16.9713 11.7512 17.9395C11.15 18.2021 10.8494 18.3334 10 18.3334C9.15062 18.3334 8.85001 18.2021 8.2488 17.9395C6.03247 16.9713 2.5 14.6913 2.5 9.99288V8.68063ZM11.6667 7.50008C11.6667 8.42056 10.9205 9.16675 10 9.16675C9.07953 9.16675 8.33333 8.42056 8.33333 7.50008C8.33333 6.57961 9.07953 5.83341 10 5.83341C10.9205 5.83341 11.6667 6.57961 11.6667 7.50008ZM10 14.1667C13.3333 14.1667 13.3333 13.4206 13.3333 12.5001C13.3333 11.5796 11.8409 10.8334 10 10.8334C8.15905 10.8334 6.66667 11.5796 6.66667 12.5001C6.66667 13.4206 6.66667 14.1667 10 14.1667Z",
    fill: "#155DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSecurity);
export default __webpack_public_path__ + "static/media/Active Security.21de358404eb75e7108ab346dbb0327c.svg";
export { ForwardRef as ReactComponent };